<template>
    <div class="page-with-top-bar">
        <section>
            <div class="mt-4">
                <b-tabs type="is-boxed" v-model="mainActiveTab">
					<b-tab-item>
						<template slot="header">
							<b-icon pack="fas" icon="project-diagram"></b-icon>
							<span> {{ $t('project_permission_types') }} </span>
						</template>
                        <PermissionTypes :company="company" @permitting-type-created="onPermittingTypeCreated" />

					</b-tab-item>

                    <b-tab-item>
                        <template slot="header">
                        <b-icon pack="fas" icon="cogs"></b-icon>
                        <span>{{ $t('permission_configuration') }}</span>
                        </template>
                        <div>
							<PermittingGroups :company="company"  ref="permittingGroups"/>
                        </div>
                    </b-tab-item>
					<b-tab-item>
						<template slot="header">
							<b-icon pack="fas" icon="list-alt"></b-icon>
							<span>{{ $t('extrafields') }}</span>
						</template>
						<div>
							<PermittingExtraFields :company="company" ref="permittingExtraFields"/>
						</div>
					</b-tab-item>
                </b-tabs>
            </div>
        </section>
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import PermissionTypes from "./permission-types.vue";
import PermittingGroups from "./permitting-groups.vue";
import PermittingExtraFields from "./permitting-extra-fields.vue";


	export default {
		middleware: "auth",
		title: "permittings",
		menuOption: "0-10",
		components: {
			PermissionTypes,
			PermittingGroups,
			PermittingExtraFields,
		},

		data: () => ({
			mainActiveTab: 0,
		}),

		computed: {
			projectId() {
				return parseInt(this.$route.params.project_id);
			},
			...mapGetters({
				company: "app/company",
			}),
		},

		methods: {
			onPermittingTypeCreated() {
				this.$refs.permittingGroups.fetchPermissionTypes();
			}
		}
	}

</script>
